import { h } from 'preact';
import { confirm } from 'utils/modal';
import { joinClasses } from 'utils/utils';

import MovieEditor from 'components/editor/movies/movieEditor';
import SelectableSection from 'components/editor/selectableSection';
import GoToMediaButton from 'components/media/goToMediaButton';

import s from 'components/editor/movies/gallery/gallery.sss';

export default class GalleryEditor extends MovieEditor {
	s = s;

	constructor(props) {
		super(props);

		this.setState({
			currentIndex: 0,
		});

		this.changeImage = this.changeImage.bind(this);
		this.addGalleryImage = this.addGalleryImage.bind(this);
	}

	// ===============================
	// HELPERS
	// ===============================
	getImages() {
		const images = this.movie?.pages?.gallery?.images || {};

		return Object.entries(images).map(([key, value]) => ({
			id: key,
			...value,
			order: value.order || 0,
		})).sort((a, b) => a.order - b.order);
	}

	changeImage(index) {
		this.setState({ currentIndex: index });
	}

	async addGalleryImage() {
		const ok = await confirm('Gallery images can be edited from the movie page media tab.', {
			title: 'Add gallery image',
			button: 'Go to media',
			buttonIconAlt: 'chevron-right',
		});
		if (!ok) return;
		
		this.navigateToMedia();
	}

	// ===============================
	// VISUAL
	// ===============================
	renderVisual() {
		const pageTitle = this.text(this.state.thundrData?.pages?.['boltGallery']?.name || '$GALLERY', 'Gallery');
		const images = this.getImages();
		const currentIndex = Math.min(this.state.currentIndex, images.length - 1);
		const currentImage = images[currentIndex] || {};
		const defaultAlt = `${this.movie?.title || 'Movie'} Gallery Image ${currentImage.order + 1}`;

		return (
			<SelectableSection class={this.s.wrapper} section="/pages/gallery" {...this.props}>
				<div class={this.s.galleryContainer}>
					<h2 class={this.s.galleryHeader}>{pageTitle}</h2>
					<div class={this.s.imageDisplay}>
						{images.length > 0 ? (
							<div class={this.s.carousel}>
								{currentImage.url ? (
									<img
										src={currentImage.url}
										class={this.s.carouselImage}
										alt={currentImage.alt || defaultAlt}
									/>
								) : (
									<div class={joinClasses(this.s.carouselImage, this.s.imagePlaceholder)} />
								)}
								{images.length > 1 && (
									<div class={this.s.indicators}>
										{images.map((_, idx) => (
											<button
												data-section="#"
												key={idx}
												class={idx === currentIndex ? this.s.indicatorActive : this.s.indicator}
												onClick={() => this.changeImage(idx)}
												aria-label={`View image ${idx + 1}`}
											/>
										))}
									</div>
								)}
								{currentImage.caption && (
									<p class={this.s.caption}>{currentImage.caption}</p>
								)}
							</div>
						) : (
							<div class={this.s.emptyState} onClick={this.addGalleryImage} style={{ cursor: 'pointer' }}>
								<p>+ Add images</p>
							</div>
						)}
					</div>
				</div>
			</SelectableSection>
		);
	}

	// ===============================
	// SETTINGS SIDEBAR
	// ===============================
	renderSettings() {
		return (
			<div class={this.s.settings}>
				{this.renderSettingsNavigation([{ label: 'Gallery', path: '/pages/gallery' }])}
				<span>Gallery images can be edited from the movie page media tab.</span>
				<GoToMediaButton dark movie={this.movie} />
			</div>
		);
	}
}
